import styled from 'styled-components';

export const TopicCarouselWrapper = styled.div`
  margin-top: 30px;
  text-align: center;

  [class*='FunctionalCarouselstyle__CarouselDotPagerList-sc'] {
    display: none;
  }

  [class*='Interactionstyle__Button-sc'] {
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc'] {
    button {
      border: none !important;
    }

    path {
      stroke: #e60000;
    }
    
    @media (max-width: 768px) {
      display:none;
    }
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc']:first-of-type {
    right: 101%;
    top: 65%;
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc']:last-of-type {
    left: 101%;
    top: 65%;
  }
`;

export const TopicCarouselCard = styled.div<{ isSelected: boolean }>`
  height: 100%;
  display: flex;
  text-align: center;
  padding: 0 3px;
  border: ${props =>
    props.isSelected ? '2px solid #00697C' : '1px solid #7e7e7e'};
  vertical-align: middle;
  background-color: var(--white);
  overflow: hidden;
  border-radius: 6px;
  cursor: pointer;
`;

export const CustomCarouselCard = styled.div<{ isDisabled: boolean }>`
  height: 100%;
  display: flex;
  text-align: center;
  padding: 0 3px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' 
  height='100%25' 
  xmlns='http://www.w3.org/2000/svg'%3e%3crect 
  width='100%25' height='100%25' fill='none' rx='6' ry='6' 
  stroke='black' stroke-width='1' stroke-dasharray='10' 
  stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 6px;
  vertical-align: middle;
  background-color: ${props =>
    props.isDisabled === false ? 'var(--white)' : '#ccc'};
  overflow: hidden;

  ${props => props.isDisabled === false && 'cursor: pointer;'};
`;

export const IconWrapper = styled.div`
  margin-top: 15px;
`;
